import React, { useState } from 'react';

import ImageAsset from "components/common/assets/ImageAsset";
import VideoAsset from "components/common/assets/VideoAsset";
import Footer from "components/common/Footer";
import Navbar from "components/common/Navbar";
import BackToAllProjects from 'components/common/BackToAllProjects';

const Huit = (props) => {
    const [showDescription, setShowDescription] = useState(false);

    const project = props.project;
    return (
        <>
            <Navbar />
            <section id="project-details" className="mt-16">
                <div className="grid grid-cols-12 px-4">
                    <div className="col-span-12 md:col-span-6">
                        <h1 className="mb-7 text-[3rem] font-medium tracking-tight">{project.name}</h1>
                        <p className="text-gray-700 text-[1.1rem]">{project.description}</p>
                    </div>
                    <div className="hidden md:col-span-6 md:flex flex-col justify-end items-end">
                        {/* Toggle Button */}
                        {project.additional_description &&
                            <div className="mt-4">
                                <button
                                    onClick={() => setShowDescription(!showDescription)}
                                    className="bg-pink-500 hover:bg-pink-700 text-white font-semibold py-2 px-4 rounded"
                                >
                                    {showDescription ? 'Just the deliverables please!' : 'More about the project'}
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </section>



            <section id="project-assets-texts" className="mt-10 px-4">
                {/* Flex container for transitioning */}
                <div className="flex flex-wrap transition-all duration-700 ease-in-out h-[100%]">
                    {/* Left Assets Section */}
                    <div
                        className={`transition-all duration-700 ease-in-out overflow-hidden ${showDescription ? 'basis-full md:basis-3/5' : 'basis-full'
                            } grow`}
                    >
                        {project.assets.map((asset, index) =>
                            asset.asset_type === 'image' ? (
                                <ImageAsset key={index} asset={asset} assetStyles="w-full mb-2 max-h-[95vh] object-cover" />
                            ) : asset.asset_type === 'video' ? (
                                <VideoAsset key={index} asset={asset} assetStyles="w-full mb-2 max-h-[95vh] object-cover" />
                            ) : null
                        )}
                    </div>

                    {/* Right Initially Hidden Additional Description Section */}
                    <div
                        // This particular code is very important the style one. Otherwise, 
                        // a bug was being generated where extra space was being rendered below 
                        // the section mainly due to the toggled height taking effect early.
                        style={{
                            height: showDescription ? 'auto' : 0,
                        }}
                        className={`hidden md:block transition-all duration-700 ease-in-out overflow-hidden ${showDescription
                            ? 'basis-full md:basis-2/5 opacity-100 translate-x-0'
                            : 'basis-0 opacity-0 -translate-x-5'
                            } grow`}
                    >
                        <div className="px-6 transition-opacity duration-700 ease-in-out">
                            {/* whitespace-pre-line is the thing that is line breaking the textarea as it is in the directus */}
                            <div
                                className="wysiwyg-content text-[1.15rem]"
                                dangerouslySetInnerHTML={{ __html: project.additional_description }}
                            />
                        </div>
                    </div>
                    <div className='block md:hidden'>
                        <p className="mt-8 text-gray-700 text-[1.15rem]">
                            <div
                                className="wysiwyg-content text-[1.15rem]"
                                dangerouslySetInnerHTML={{ __html: project.additional_description }}
                            />
                        </p>
                    </div>
                </div>
            </section>

            <BackToAllProjects customStyle="text-center text-[1.7rem] text-pink-400 mt-10" />
            <Footer />
        </>
    )
}

export default Huit;